import { Component, OnInit, Input, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserDocumentService } from '../../services/user-document.service';
import { AssetService } from 'src/app/services/asset.service';

export interface PeriodicElement {
  email: string;
  name: string;
  date: string;
  role: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  { name: 'demo', email: 'demo@gmail.com', date: '23-21-2020', role: 'Investigation Officer' },
  { name: 'demo1', email: 'demo@gmail.com', date: '23-21-2020', role: 'Investigation Officer' },
  { name: 'demo1', email: 'demo@gmail.com', date: '23-21-2020', role: 'Investigation Officer' },
  { name: 'demo1', email: 'demo@gmail.com', date: '23-21-2020', role: 'Investigation Officer' },
  { name: 'demo1', email: 'demo@gmail.com', date: '23-21-2020', role: 'Investigation Officer' },
  { name: 'demo1', email: 'demo@gmail.com', date: '23-21-2020', role: 'Investigation Officer' },
  { name: 'demo1', email: 'demo@gmail.com', date: '20-10-1920', role: 'Investigation Officer' },
  { name: 'demo1', email: 'demo@gmail.com', date: '23-21-2020', role: 'Investigation Officer' },
  { name: 'demo1', email: 'demo@gmail.com', date: '23-21-2020', role: 'Investigation Officer' },
  { name: 'demo1', email: 'demo@gmail.com', date: '23-21-2020', role: 'Investigation Officer' },
];

@Component({
  selector: 'app-all-form-list',
  templateUrl: './all-form-list.component.html',
  styleUrls: ['./all-form-list.component.scss']
})
export class AllFormListComponent implements OnInit {

  @Input('accident') accidentData
  @Input('user') userData
  @Input('role') roleOfUser
  @Input('type') typeOfAccident
  @Input('formName') displayForm
  @Input('accidentUser') userAccident
  displayedColumns: string[] = ['name', 'email', 'date', 'role', 'action'];
  previousIndex: any;
  dataSource = ELEMENT_DATA;
  isWitness = false
  isReport = false
  isInvestigation = false
  isReport2 = false
  userId
  accidentId
  userDetails
  incidentReportData
  userRole
  loading: boolean;
  accidentType
  isGoodPractice = false
  isCloseCall = false
  userForm
  constructor(
    public activatedRouter: ActivatedRoute,
    public _userDocumentService: UserDocumentService,
    public _cd: ChangeDetectorRef,
    public _assetService: AssetService,
  ) {

  }

  ngOnInit() {
    this.loading = false
    this._assetService.closeDisplayFile(true)
    this.activatedRouter.queryParams.subscribe((param) => {
      console.log("param data", param);
      this.userId = param.userId
      this.accidentId = param.accidentId
      this.accidentType = param.accidentType
      if (param.accidentId && param.userId) {
        this.getUserDocumentData(param)
      }
      // switch (param.userRole) {
      //   case 'witness': return this.isWitness = true;
      //   case 'reporter': return this.isReport = true;
      //   case 'officer': return this.isInvestigation = true;
      //   default: return this.isWitness && this.isReport && this.isInvestigation == false
      // }



    })


  }


  ngOnChanges(changes: SimpleChanges): void {
    console.log("CHANGES in child component", changes);

    if (changes.userAccident && changes.userAccident.currentValue) {
      console.log("this is the final object to get", changes.userAccident.currentValue);
      let details = changes.userAccident.currentValue
      this.accidentId = details.selectedAccident
      this.userId = details.userId
      this.accidentType = details.accidetnType
      this.userForm = details.userForm
      this.userRole = details.userRole
      this.checkTab(this.userRole)

      let obj = {
        userId: this.userId,
        accidentId: this.accidentId,
        userRole: this.userRole.userRole
      }
      this.getUserDocumentData(obj)
    }



  }




  // UTILITY
  checkTab(data) {
    console.log("data in all form list------>", data)
    console.log("userrole=======================>", data.userRole, this.isGoodPractice, this.isWitness, this.accidentType);

    if (this.accidentType == 'goodPractice') {
      this.isGoodPractice = true
      this.isWitness = false
      this.isInvestigation = false
      this.isReport = false
      this.isReport2 = false
      this.isCloseCall = false
    } else if (this.accidentType == 'closeCall') {
      if (data.userRole == 'witness') {
        this.isGoodPractice = false
        this.isWitness = true
        this.isInvestigation = false
        this.isReport = false
        this.isReport2 = false
        this.isCloseCall = false
      } else if (data.userRole == 'officer') {
        this.isGoodPractice = false
        this.isWitness = false
        this.isInvestigation = true
        this.isReport = false
        this.isReport2 = false
        this.isCloseCall = false
      } else {
        this.isGoodPractice = false
        this.isWitness = false
        this.isInvestigation = false
        this.isReport = false
        this.isReport2 = false
        this.isCloseCall = true
      }
    } else {
      if (data.userRole == 'witness') {
        this.isGoodPractice = false
        this.isWitness = true
        this.isInvestigation = false
        this.isReport = false
        this.isReport2 = false
        this.isCloseCall = false
      } else if (data.userRole == 'officer') {
        this.isGoodPractice = false
        this.isWitness = false
        this.isInvestigation = true
        this.isReport = false
        this.isReport2 = false
        this.isCloseCall = false
      } else {
        if (data.userForm == 'envForm' || this.userForm == 'envForm') {
          this.isGoodPractice = false
          this.isWitness = false
          this.isInvestigation = false
          this.isReport = true
          this.isReport2 = false
          this.isCloseCall = false
        } else {
          this.isGoodPractice = false
          this.isWitness = false
          this.isInvestigation = false
          this.isReport = false
          this.isReport2 = true
          this.isCloseCall = false
        }
      }
    }
  }


  fileDetails(event) {
    console.log("hey this event emit call ")
    console.log("event ====", event.event.file);
    this.previousIndex = event.event.index
    this._assetService.displayFile(event)
    // this.openFilesSideNav.emit({ event })
  }


  // API CALL


  getUserDocumentData(param) {
    console.log("params details", param);
    this.loading = true
    this._userDocumentService.getUserDocument(param).subscribe((response) => {
      // this.userDetails = {}
      console.log("response of document data", response);
      console.log("this is for one document");
      // this.loading = false
      this.checkTab(response.userData)
      setTimeout(() => {
        this.userDetails = response
      }, 500)
      this.loading = false
      console.log("this is final user details to be send", this.incidentReportData);
    }, error => {
      console.log("error", error);
      this.loading = false
    })

  }

}
